/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthNoticeResponse } from './AuthNoticeResponse';

export type AuthNoticeResponseApiRespoonse = {
    data?: AuthNoticeResponse;
    status?: AuthNoticeResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuthNoticeResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

